// Admin Fortune Teller Management — Add/Edit/Delete fortune teller profiles
import { renderHeader, renderBottomNav } from '../components/header.js';
import { requireAdmin } from '../auth.js';
import { toastSuccess, toastError } from '../components/toast.js';
import { getAllFortuneTellers, saveFortuneTeller, deleteFortuneTellerDB } from '../services/db.js';
import { showConfirm } from '../utils/dialog.js';

let editingFt = null;

export async function renderAdminFortuneTellers() {
    const allowed = await requireAdmin();
    if (!allowed) return;

    const app = document.getElementById('app');
    app.innerHTML = `${renderHeader()}<div class="page"><div style="text-align:center;padding:var(--space-xl);"><div class="loading-spinner"></div><p class="text-muted mt-md">กำลังโหลด...</p></div></div>${renderBottomNav('admin-settings')}`;

    const tellers = await getAllFortuneTellers();

    app.innerHTML = `
    ${renderHeader()}
    <div class="page">
      <div class="flex-between mb-lg">
        <h2 class="page-title" style="margin:0;">🔮 จัดการหมอดู</h2>
        <button class="btn btn-sm btn-gold" id="add-ft-btn">+ เพิ่ม</button>
      </div>

      <!-- Fortune Teller Form (hidden by default) -->
      <div id="ft-form" class="card mb-lg ${editingFt ? '' : 'hidden'}">
        <h3 style="color:var(--accent-gold);margin-bottom:var(--space-md);" id="form-title">${editingFt ? '✏️ แก้ไขข้อมูล' : '➕ เพิ่มหมอดูใหม่'}</h3>
        <div class="form-group">
          <label class="form-label">ชื่อ *</label>
          <input class="form-input" type="text" id="ft-name" value="${editingFt?.name || ''}" placeholder="ชื่อหมอดู" />
        </div>
        <div class="form-group">
          <label class="form-label">ความเชี่ยวชาญ</label>
          <input class="form-input" type="text" id="ft-specialty" value="${editingFt?.specialty || ''}" placeholder="เช่น ไพ่ยิปซี, โหราศาสตร์" />
        </div>
        <div class="form-group">
          <label class="form-label">รายละเอียด</label>
          <textarea class="form-textarea" id="ft-bio" rows="2" placeholder="ประสบการณ์ ความเชี่ยวชาญ">${editingFt?.bio || ''}</textarea>
        </div>
        <div class="form-group">
          <label class="form-label">URL รูปภาพ</label>
          <input class="form-input" type="url" id="ft-picture" value="${editingFt?.pictureUrl || ''}" placeholder="https://..." />
        </div>
        <h4 style="color:var(--text-secondary);margin:var(--space-md) 0 var(--space-sm);">📌 วิธีการจอง (Services)</h4>
        <div class="form-group">
          <div style="display:flex; gap:8px;">
            <input type="text" id="ft-new-service" class="form-input" placeholder="เช่น นัดพบ, แชท, วิดีโอคอล" />
            <button class="btn btn-outline" id="add-service-btn" style="flex-shrink:0;">+ เพิ่ม</button>
          </div>
          <div id="ft-services-container" style="display:flex; flex-wrap:wrap; gap:8px; margin-top:12px;"></div>
        </div>
        <div class="flex gap-sm mt-md">
          <button class="btn btn-outline btn-block" id="cancel-ft-btn">ยกเลิก</button>
          <button class="btn btn-primary btn-block" id="save-ft-btn">💾 บันทึก</button>
        </div>
      </div>

      <!-- Fortune Teller List -->
      <div id="ft-list">
        ${tellers.length > 0 ? tellers.map(ft => renderFTCard(ft)).join('') : `
          <div class="empty-state">
            <div class="empty-state-icon">🔮</div>
            <div class="empty-state-title">ยังไม่มีข้อมูลหมอดู</div>
            <div class="empty-state-text">กดปุ่ม "+ เพิ่ม" เพื่อเพิ่มข้อมูลหมอดู</div>
          </div>
        `}
      </div>

      <div class="mt-lg">
        <button class="btn btn-outline btn-block" onclick="location.hash='#/admin/settings'">← กลับตั้งค่า</button>
      </div>
    </div>
    ${renderBottomNav('admin-settings')}
  `;

    bindEvents(tellers);
}

function renderFTCard(ft) {
    const srvTags = (ft.services || []).map(s => `<span style="background:var(--bg-card);border:1px solid var(--border-color);border-radius:12px;padding:2px 8px;font-size:10px;">${s}</span>`).join(' ');
    return `
    <div class="card mb-sm" id="ft-item-${ft.id}">
      <div class="card-header">
        <img class="card-avatar" src="${ft.pictureUrl || 'https://ui-avatars.com/api/?name= FT &background=9b59f0&color=fff&size=56'}" alt="${ft.name}"
             onerror="this.onerror=null; this.src='https://ui-avatars.com/api/?name= FT &background=9b59f0&color=fff&size=56'" />
        <div class="card-info">
          <h3>${ft.name}</h3>
          <p>${ft.specialty || '-'}</p>
        </div>
      </div>
      ${ft.bio ? `<div class="card-body"><p class="text-sm">${ft.bio}</p></div>` : ''}
      <div class="card-footer">
        <div style="display:flex; gap:4px; flex-wrap:wrap; flex:1;">${srvTags}</div>
        <div class="flex gap-xs">
          <button class="btn btn-sm btn-outline edit-ft-btn" data-id="${ft.id}">✏️ แก้ไข</button>
          <button class="btn btn-sm btn-danger delete-ft-btn" data-id="${ft.id}">🗑️</button>
        </div>
      </div>
    </div>
  `;
}

function bindEvents(tellers) {
    let currentServices = [];
    function renderServices() {
        const container = document.getElementById('ft-services-container');
        if (!container) return;
        container.innerHTML = currentServices.map((srv, index) => `
            <div style="background:var(--primary-color);color:#fff;padding:4px 12px;border-radius:16px;font-size:12px;display:flex;align-items:center;gap:4px;">
                ${srv}
                <span style="cursor:pointer;font-weight:bold;margin-left:4px;" data-index="${index}" class="remove-service-btn">&times;</span>
            </div>
        `).join('');
        container.querySelectorAll('.remove-service-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                currentServices.splice(parseInt(e.target.dataset.index), 1);
                renderServices();
            });
        });
    }

    document.getElementById('add-service-btn')?.addEventListener('click', (e) => {
        e.preventDefault(); 
        const input = document.getElementById('ft-new-service');
        const val = input.value.trim();
        if (val && !currentServices.includes(val)) {
            currentServices.push(val);
            input.value = '';
            renderServices();
        }
    });

    // Add button
    document.getElementById('add-ft-btn')?.addEventListener('click', () => {
        editingFt = null;
        currentServices = [];
        renderServices();
        document.getElementById('ft-form')?.classList.remove('hidden');
        document.getElementById('form-title').textContent = '➕ เพิ่มหมอดูใหม่';
        ['ft-name', 'ft-specialty', 'ft-bio', 'ft-picture'].forEach(id => {
            const el = document.getElementById(id); if (el) el.value = '';
        });
    });

    // Cancel
    document.getElementById('cancel-ft-btn')?.addEventListener('click', () => {
        editingFt = null;
        document.getElementById('ft-form')?.classList.add('hidden');
    });

    // Save
    document.getElementById('save-ft-btn')?.addEventListener('click', async () => {
        const name = document.getElementById('ft-name')?.value?.trim();
        if (!name) { toastError('กรุณากรอกชื่อหมอดู'); return; }

        const btn = document.getElementById('save-ft-btn');
        btn.disabled = true;
        btn.textContent = '⏳ กำลังบันทึก...';

        const ftData = {
            name,
            specialty: document.getElementById('ft-specialty')?.value || '',
            bio: document.getElementById('ft-bio')?.value || '',
            pictureUrl: document.getElementById('ft-picture')?.value || '',
            services: currentServices
        };

        if (editingFt?.id) ftData.id = editingFt.id;
        await saveFortuneTeller(ftData);
        editingFt = null;
        toastSuccess('บันทึกข้อมูลหมอดูแล้ว ✅');
        renderAdminFortuneTellers();
    });

    // Edit buttons
    document.querySelectorAll('.edit-ft-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const ft = tellers.find(t => t.id === btn.dataset.id);
            if (!ft) return;
            editingFt = ft;
            document.getElementById('ft-form')?.classList.remove('hidden');
            document.getElementById('form-title').textContent = '✏️ แก้ไขข้อมูล';
            document.getElementById('ft-name').value = ft.name || '';
            document.getElementById('ft-specialty').value = ft.specialty || '';
            document.getElementById('ft-bio').value = ft.bio || '';
            document.getElementById('ft-picture').value = ft.pictureUrl || '';
            currentServices = Array.isArray(ft.services) ? [...ft.services] : [];
            renderServices();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });

    // Delete buttons
    document.querySelectorAll('.delete-ft-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
            if (await showConfirm('ต้องการลบหมอดูนี้?')) {
                await deleteFortuneTellerDB(btn.dataset.id);
                toastSuccess('ลบหมอดูแล้ว');
                renderAdminFortuneTellers();
            }
        });
    });
}
